// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"Dashboard_dashboard__2LEbn","dashboardGrid":"Dashboard_dashboardGrid__3YEVr","dashboardGridItem":"Dashboard_dashboardGridItem__32JHc"};